import getDetail from "@/api/endpoint/project/get-detail";
import getNumberNewReview from "@/api/endpoint/project/get-number-new-review";
import { trackingProject } from "@/api/endpoint/project/tracking-project";
import { getListFileReviewProject } from "@/api/endpoint/reviews/get-list-file-review-project";
import { getListReviewProject } from "@/api/endpoint/reviews/get-list-review-project";
import { DeviceContext } from "@/context/device.context";
import { ProjectContextProvider } from "@/context/project.context";
import ProjectDetail from "@/modules/Desktop/ProjectDetail";
//import Home from '@/modules/Desktop/Home'
//import HomeMobile from '@/modules/Mobile/Home'
import Button from "@/components/Button";
import { USER_TYPE } from "@/constants/common-constant";
import { MediaTypeEnum } from "@/constants/enum/media";
import { MEEY_REVIEW_API_URL, STATIC_DOMAIN } from "@/constants/environment";
import { PAGE_SIZE_FILE } from "@/constants/number";
import { DEFAULT_LOGO_PROJECT } from "@/constants/project-constant";
import { getCanonicalUrl } from "@/extensions/route";
import ProjectDetailMobile from "@/modules/Mobile/ProjectDetailMobile";
import { resizeOnFlyUrl } from "@/utils";
import { Meta } from "@components/Seo/Meta";
import { getCookie } from "cookies-next";
import { GetServerSidePropsContext } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useContext, useEffect } from "react";
import axios from "axios";
import { useAuth } from "@/hooks/useAuth";
import { getListVideoProject } from "@/api/endpoint/project/get-list-project-video";

// const HomeMobile = dynamic(() => import('@/modules/Mobile/Home'))

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { params, query } = context;
  const { id, ...otherQuery } = query;
  const headers = getCookie("headers", {
    ...context,
  });
  try {
    const project = await getDetail(id as string);

    const [projectListVote, projectListFile, numberNewReview, projectVideos] =
      await Promise.allSettled([
        await getListReviewProject(
          project._id,
          {
            sort: "publishedAt:desc",
            ...otherQuery,
          },
          headers
            ? {
                ...JSON.parse(`${headers}`),
              }
            : {
                usertype: USER_TYPE.ANONYMUS,
                fingerprint: `${Math.random()}`,
              }
        ),
        await getListFileReviewProject(project._id, {
          type: `${MediaTypeEnum.IMAGE},${MediaTypeEnum.VIDEO},${MediaTypeEnum.FILE}`,
          limit: PAGE_SIZE_FILE,
          page: 1,
        }),

        await getNumberNewReview(project._id),
        await getListVideoProject(project.shortId),
      ]).then((results) =>
        results.map((result: any) => {
          return result.status === "fulfilled" ? result.value : null;
        })
      );
    // console.log(projectVideos);
    return {
      props: {
        project,
        projectListVote,
        projectListFile,
        projectVideos,
        params,
        numberNewReview,
      },
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
}

export default function PageSlug(props: any) {
  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, []);
  const { isMobile } = useContext(DeviceContext);
  const router = useRouter();

  const { userDataHeader } = useAuth();
  const handleTracking = useCallback(async () => {
    if (userDataHeader)
      try {
        await trackingProject(props.project?._id);
        await axios.request({
          method: "post",
          headers: userDataHeader,
          baseURL: MEEY_REVIEW_API_URL,
          url: "v1/interact/createview/" + props.project?._id,
        });
      } catch (error) {}
  }, [props.project?._id, userDataHeader]);
  useEffect(() => {
    handleTracking();
  }, [handleTracking]);
  return (
    <>
      {props.project ? (
        <>
          <Meta
            title={props.project.title}
            description={props.project.description}
            ogImage={{
              width: 600,
              height: 315,
              url: props.project.logo?.uri
                ? resizeOnFlyUrl({
                    resizingType: "fill",
                    gravity: "ce",
                    width: 600,
                    height: 315,
                    uri: props.project.logo.uri,
                  })
                : props.project.logo?.url
                ? props.project.logo?.url
                : STATIC_DOMAIN + "/" + DEFAULT_LOGO_PROJECT,
              alt: props.project.title,
            }}
            canonical={getCanonicalUrl(router)}
          />
          <ProjectContextProvider
            project={props.project}
            projectListVote={props.projectListVote}
            projectListFile={props.projectListFile}
            checkFollowProject={props.checkIsFollowProject}
            projectVideos={props.projectVideos}
            numberNewReview={props.numberNewReview}>
            {isMobile ? (
              <ProjectDetailMobile {...props} />
            ) : (
              <ProjectDetail {...props} />
            )}
          </ProjectContextProvider>
        </>
      ) : (
        <div className="w-screen h-[100vh] gap-8 flex items-center justify-center flex-col">
          <h1>Không tìm thấy dự án</h1>
          <Link href={"/"}>
            <Button btnType="filled">Về trang chủ</Button>
          </Link>
        </div>
      )}
    </>
  );
}
